export const teamMemberDetails = {
  harini: {
    id: "1",
    name: "Harini S",
    designation: "Backend Engineer",
    coverImage:
      "https://wfkq0nguanh0273r.public.blob.vercel-storage.com/team-bg.png",
    profileImage:
      "https://www.securosphere.in/static/media/network-protection-1.4d9e425a677c32d2a8ea.png",
    professionalSummary:
      "Passionate developer with 1+ years of experience in building scalable web applications. Specialized in React, TypeScript, and cloud technologies.",
    education: [
      {
        degree: "Bachelor of Technology in Computer Science",
        institution: "SSMIET",
        year: "2025",
      },
    ],
    skills: ["React", "TypeScript", "Node.js", "AWS", "Docker", "GraphQL"],
    dailyActivities: [
      "Code review sessions",
      "Team standups",
      "Architecture discussions",
      "Mentoring junior developers",
    ],
    inspirations: [
      "Open source community",
      "Clean code principles",
      "User-centric design",
    ],
    ambition:
      "To build scalable solutions that make a positive impact on millions of users",
    favoriteTool: "VS Code with various extensions",
    favoritePlace: "Swiss Alps",
    favoriteQuote: "The best way to predict the future is to create it.",
    alternativeCareer: "Professional photographer",
    socialLinks: {
      linkedin: "https://linkedin.com/in/harinis",
      twitter: "https://twitter.com/harinis",
      github: "https://github.com/harinis",
    },
  },
};
